<template>
  <div class='reputation-grid'>
    <h1 class="reputation-text">REPUTATION</h1>
  </div>
</template>

<script>

export default {
  name: 'Reputation',
  data() {
    return {
      pageValue: {
        link: {
          title: 'competition',
          linkId: 'Reputation',
        },
      },
    };
  },
  mounted() {
    this.$store.dispatch('global/addPageLinkHighlightAndNavLinkBorder', this.pageValue);
  },
  destroyed() {
    this.$destroy();
  },
};
</script>

<style scoped>
.reputation-grid {
  display: grid;
  grid-template-columns: 75px repeat(16, auto) 75px;
  grid-template-rows: 25px repeat(16, minmax(100px, auto)) 25px;
}
.reputation-text {
  grid-row: 3 / 6;
  grid-column: 2 / 5;
}
</style>
